export default "__VITE_ASSET__gleJc86b__"